window.AvailableMegaMenus = [];

document.addEventListener('alpine:init', () => {
  Alpine.store("header", {
    hoveredMenuLink: null,
    openedMegamenu: null,
    lastScrollPosition: window.pageYOffset | document.body.scrollTop,
    isScrollingEnabled: true,
    isCartVisorVisible: false,    
    cartVisorClosesAutomatically: true,
    cartVisorCountdownMessage: "",
    cartVisorCountdownInterval: null,
    cartVisorCountdownTimeout: null,
    isMobileVisorVisible: false,
    isSearchVisible: false,
    isScrollForcedBlocked: false, // this is used by visors that are outside of this store's control. Ex. collection filter visor in mobile
    isStickyProductSummaryVisible: false, // the bar that shows up depending on isProductFormPageIntersecting
    isStickyVariantSelectorVisible: false, // when we press edit in StickyProductSummary
    isProductFormPageIntersecting: false, // the product form is visible in page, but are we currently scrolled to it?
    init() {
      const updateMenuSensitiveStickyContent = () => {
        console.log("updateMenuSensitiveStickyContent");
        this.isProductFormPageIntersecting
          ? this.onProductFormScrolledInView()
          : this.onProductFormScrolledOutOfView();

        this.refreshScrollingState();
      }

      this.$watch && this.$watch("isProductFormPageIntersecting", updateMenuSensitiveStickyContent);
      this.$watch && this.$watch("isMobileVisorVisible", updateMenuSensitiveStickyContent);
      this.$watch && this.$watch("isCartVisorVisible", updateMenuSensitiveStickyContent);
      this.$watch && this.$watch("isSearchVisible", updateMenuSensitiveStickyContent);
      this.$watch && this.$watch("openedMegamenu", updateMenuSensitiveStickyContent);      

      const openApplicableMegaMenu = (menu) => {
        const megaMenuExists = document.querySelector(`[data-mega-menu="${menu}"]`);
        if (megaMenuExists) {
          this.openedMegamenu = menu;
        } else {
          this.openedMegamenu = null;
        }

        this.refreshScrollingState();
      }

      this.$watch && this.$watch("hoveredMenuLink", openApplicableMegaMenu);

      this.$watch && this.$watch("isStickyVariantSelectorVisible", this.refreshScrollingState.bind(this));
      this.$watch && this.$watch("isMobileVisorVisible", this.refreshScrollingState.bind(this));

      setTimeout(updateMenuSensitiveStickyContent, 800); // for initial page refresh, wait a bit as intersect can be initialized as true if loaded too fast.
    },
    blockBodyScrolling(block = true) {          
      this.isScrollForcedBlocked = block;
      this.refreshScrollingState();
    },
    isAnyKindOfMenuShowing() {
      return this.openedMegamenu != null || this.isSearchVisible || this.isMobileVisorVisible || this.isCartVisorVisible
    },
    isAnyScrollBlockingMenusShowing() {
      if (this.isScrollForcedBlocked) {
        return true;
      }

      return this.isMobileVisorVisible 
        || this.isCartVisorVisible 
        || this.isStickyVariantSelectorVisible
        || this.isSearchVisible
    },
    refreshScrollingState() {
      this.isScrollingEnabled = !this.isAnyScrollBlockingMenusShowing();
    },
    onProductFormScrolledOutOfView() {      
      if (!this.isAnyKindOfMenuShowing()) {
        this.isStickyProductSummaryVisible = true;
      } else {
        this.isStickyProductSummaryVisible = false;
        this.isStickyVariantSelectorVisible = false;
      }
    },
    onProductFormScrolledInView() {
      this.isStickyProductSummaryVisible = false;
    },
    openStickyVariantSelector(open = true) {
      this.isStickyVariantSelectorVisible = open;
      this.isStickyProductSummaryVisible = !open
    },
    openCartVisor(open = true) {
      this.isCartVisorVisible = open;
      if (open) {
        this.openStickyVariantSelector(false);
      }
      
      if (!open) {
        this.isCartVisorVisible = false;
        this.clearAutoClose();
      }
    },
    startDelayedClosing() {
      if (!this.cartVisorClosesAutomatically) {
        return;
      }

      this.clearAutoClose();

      let s = parseInt(`${window.theme.closeVisorAfterSeconds}`); // clone
      this.cartVisorCountdownMessage = `Automatically closing in ${s} seconds`;
      this.cartVisorCountdownInterval = setInterval(() => {
        this.cartVisorCountdownMessage = `Automatically closing in ${--s} seconds`;          
      }, 1000);        
      this.cartVisorCountdownTimeout = setTimeout(() => {
        this.isCartVisorVisible = false;
        this.clearAutoClose();
      }, s * 1000);
    },
    clearAutoClose() {      
      this.cartVisorCountdownMessage = "";
      clearInterval(this.cartVisorCountdownInterval);
      clearTimeout(this.cartVisorCountdownTimeout);      
    }    
  });

  // window.onscroll=function(){
  //   Alpine.store("header").lastScrollPosition = window.pageYOffset | document.body.scrollTop;
  // }
});

window.onload = function() {
  const swiper = new Swiper('.swiper', {
    // Optional parameters
    direction: 'horizontal',
    loop: true,
    centeredSlides: true,
    spaceBetween: 20,
    slidesPerView: 2,
    slideToClickedSlide: true,
    breakpoints: {
      764: {
        loop: false,
        centeredSlides: false,
        slidesPerView: 3,
        spaceBetween: 20,
      },
      1200: {
        loop: false,
        centeredSlides: false,
        slidesPerView: 5,
        spaceBetween: 30
      },
    },
    scrollbar: {
      el: '.swiper-scrollbar',
      draggable: true
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    }
  });
  
  const swiperVisor = new Swiper('.swiper-visor', {
    // Optional parameters
    direction: 'horizontal',
    loop: true,
    centeredSlides: false,
    spaceBetween: 15,
    slidesPerView: 2,
    slideToClickedSlide: true,
    breakpoints: {
      390: {
        spaceBetween: 15,
        loop: true,
        centeredSlides: false,
        slidesPerView: 2,
        spaceBetween: 15
      },
      764: {
        loop: false,
        centeredSlides: false,
        slidesPerView: 4,
        spaceBetween: 20
      },
      1200: {
        loop: false,
        centeredSlides: false,
        slidesPerView: 5,
        spaceBetween: 30,
      },
    },
    scrollbar: {
      el: '.swiper-scrollbar',
      draggable: true
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
      hiddenClass: '.swiper-hide'
    }
  });
  
}